const IKnowAnOldLadyWhoSwallowedAFly = [
	'[VERSE 1]',
	'I know an old lady who swallowed a fly.',
	'I dunno why she swallowed that fly,',
	"Perhaps she'll die.",
	'',
	'[VERSE 2]',
	'I know an old lady who swallowed a spider,',
	'That wriggled and jiggled and tickled inside her.',
	'She swallowed the spider to catch the fly.',
	'But I dunno why she swallowed that fly -',
	"Perhaps she'll die.",
	'',
	'[VERSE 3]',
	'I know an old lady who swallowed a bird;',
	'How absurd, to swallow a bird!',
	'She swallowed the bird to catch the spider',
	'That wriggled and jiggled and tickled inside her.',
	'She swallowed the spider to catch the fly.',
	'But I dunno why she swallowed that fly -',
	"Perhaps she'll die.",
	'',
	'[VERSE 4]',
	'I know an old lady who swallowed a cat.',
	'Imagine that, she swallowed a cat.',
	'She swallowed the cat to catch the bird ...',
	'She swallowed the bird to catch the spider',
	'That wriggled and jiggled and tickled inside her.',
	'She swallowed the spider to catch the fly.',
	'But I dunno why she swallowed that fly -',
	"Perhaps she'll die.",
	'',
	'[VERSE 5]',
	'I know an old lady who swallowed a dog.',
	'What a hog! To swallow a dog!',
	'She swallowed the dog to catch the cat...',
	'She swallowed the cat to catch the bird ...',
	'She swallowed the bird to catch the spider',
	'That wriggled and jiggled and tickled inside her.',
	'She swallowed the spider to catch the fly.',
	'But I dunno why she swallowed that fly -',
	"Perhaps she'll die.",
	'',
	'[VERSE 6]',
	'I know an old lady who swallowed a goat.',
	'Just opened her throat and swallowed a goat!',
	'She swallowed the goat to catch the dog ...',
	'She swallowed the dog to catch the cat...',
	'She swallowed the cat to catch the bird ...',
	'She swallowed the bird to catch the spider',
	'That wriggled and jiggled and tickled inside her.',
	'She swallowed the spider to catch the fly.',
	'But I dunno why she swallowed that fly -',
	"Perhaps she'll die.",
	'',
	'[VERSE 7]',
	'I know an old lady who swallowed a cow.',
	"I don't know how she swallowed a cow!",
	'She swallowed the cow to catch the goat...',
	'She swallowed the goat to catch the dog ...',
	'She swallowed the dog to catch the cat...',
	'She swallowed the cat to catch the bird ...',
	'She swallowed the bird to catch the spider',
	'That wriggled and jiggled and tickled inside her.',
	'She swallowed the spider to catch the fly.',
	'But I dunno why she swallowed that fly -',
	"Perhaps she'll die.",
	'',
	'[VERSE 8]',
	'I know an old lady who swallowed a horse -',
	'',
	'[VERSE 9]',
	"She's dead, of course.",
];

export default IKnowAnOldLadyWhoSwallowedAFly;
